import React from 'react';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Page from 'Components/Page';
import { withStyles } from '@material-ui/core';
import PricingCardFeature from '../../Components/ProductRegistration/PricingCardFeature';
import PricingPlans from '../../Components/ProductRegistration/PricingPlans';

const styles = theme => ({
  commonFeatures: {
    marginTop: 70,
  },
  commonFeaturesHeader: {
    fontSize: 20,
    lineHeight: '30px',
    marginBottom: 15,
    textAlign: 'center',
  },
  commonFeaturesListContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
});

function Pricing({ classes }) {
  return (
    <Page>
      <Container component="main" maxWidth="lg">
        <Typography variant="h1" className={classes.pageHeader}>
          Pricing Plans
        </Typography>

        <PricingPlans />

        <div className={classes.commonFeatures}>
          <Typography variant="h6" className={classes.commonFeaturesHeader}>
            Still unsure? Some great reasons to manage registrations with Ownerfy
          </Typography>
          <div className={classes.commonFeaturesListContainer}>
            <div>
              <PricingCardFeature mainText="Incentivize customers to complete registration via convenient QR code on registration card" />
              <PricingCardFeature mainText="Download QR code image to provide to your printing company" />
              <PricingCardFeature mainText="Make your own registration forms in minutes" />
              <PricingCardFeature mainText="Pick a registration form from our gallery" />
              <PricingCardFeature mainText="Brand registration forms" />
              <PricingCardFeature mainText="Dynamic registration form that can be updated at any time" />
              <PricingCardFeature mainText="Encourage customers to leave reviews in compliance with Amazon rules" />
              <PricingCardFeature mainText="Track your registered customers" />
              <PricingCardFeature mainText="Export customers information for use in email blasts" />
            </div>
          </div>
        </div>
      </Container>
    </Page>
  );
}

export default withStyles(styles)(Pricing);
